﻿export default class PanelControl {
    constructor(rootURL, target, mapControl, resourcesHandler, classId, action, modalWrapper) {
        this.rootURL = rootURL;
        this.target = target;
        this.mapControl = mapControl;
        this.resourcesHandler = resourcesHandler;
        this.classId = classId;
        this.action = action;
        this.elementId = 'map-action-' + this.classId + '-' + this.action.Id;
        this.panelWrapper = 'panel-wrapper-' + this.classId + '-' + this.action.Id;
        this.cancelPanelId = 'cancel-panel-' + this.classId + '-' + this.action.Id;
        this.panelContainer = 'panel-container-' + this.classId + '-' + this.action.Id;
        this.visible = false;
        this.init();
    }

    init() {
        this.target.append(this._getActionButtonTemplate());
        document.getElementById(this.elementId).addEventListener('click', this._actionButtonClickHandler());
    }

    _actionButtonClickHandler() {
        return () => {
            if (this.visible) {
                this._hidePanel();
            } else {
                this._showPanel();
            }
        };
    }

    _showPanel() {
        this.visible = true;
        let tmp = document.createElement('div');
        tmp.innerHTML = this._getPanelTemplate();
        document.body.appendChild(tmp.firstChild);

        document.getElementById(this.cancelPanelId).addEventListener('click', () => {
            this._hidePanel();
        });

        if (window['xp_map_action_' + this.action.Id + '_init']) {
            window['xp_map_action_' + this.action.Id + '_init'](this);
        }
    }

    _hidePanel() {
        this.visible = false;
        let panel = document.getElementById(this.panelWrapper);
        if (panel) {
            panel.remove();
        }
    }

    _getPanelTemplate() {
        return `<div id="` + this.panelWrapper + `" style="position: fixed; top: 4rem; right: 1.5rem; z-index: 900; width: 350px; background: #fff; border-radius: 4px; box-shadow: 0 2px 12px rgba(0,0,0,0.25);">
                    <div style="display: flex; align-items: center; justify-content: space-between; padding: 8px 12px; border-bottom: 1px solid #e0e0e0;">
                        <label style="font-weight: 600; margin: 0;">` + this.action.Text + `</label>
                        <button id="` + this.cancelPanelId + `" style="background: none; border: none; cursor: pointer; font-size: 18px; padding: 0 4px; line-height: 1;" title="` + this.resourcesHandler.get('Close') + `">&times;</button>
                    </div>
                    <div style="padding: 12px;" id="` + this.panelContainer + `">
                    </div>
                </div>`;
    }

    _getActionButtonTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<li>
                            <a class="btn map-menu-item" id="` + this.elementId + `" title="` + this._getTitle() + `">
                                <i class="` + this.action.Icon + `"></i>
                            </a>
                        </li>`;
        return div.firstChild;
    }

    _getTitle() {
        if (this.action.Title != null && this.action.Title != '') {
            return this.action.Title;
        }

        return this.resourcesHandler.get('SubType_' + this.action.SubType);
    }
}